import * as React from "react"
import { Box, Center, Spinner, Text, Link, Stack, Flex, Image } from "@chakra-ui/react"
import { useQuery } from "react-query"
import { Link as RLink, useParams } from "react-router-dom"

import { SearchBar } from "./SearchBar"
import { useOrgs } from "./providers/OrgProvider"
import { BikeEntity } from "../lib/types/bike"
import { useFeatFlags } from "./providers/FeatFlagProvider"

interface BikesResponse {
  results: BikeEntity[]
  count: number
}

export const TripsBikeSearch = () => {
  const [search, setSearch] = React.useState<string>("")
  const { id } = useParams()
  const { currentOrgs } = useOrgs()
  const { bike_sn_as_name_extension } = useFeatFlags()

  const currentOrgsUuids = currentOrgs.map(({ uuid }) => uuid)

  const { data, isLoading } = useQuery<BikesResponse, string>(
    `bicycles/?page_size=5&page=1&query=${search}&organizations=${currentOrgsUuids.join()}`,
    { enabled: !!search },
  )
  React.useEffect(() => {
    if (id) setSearch("")
  }, [id])
  const bikes = data?.results

  return (
    <Box pos="relative">
      <SearchBar onSearchSubmit={setSearch} search={search} />
      {!!search && (isLoading || !!bikes) && (
        <Box
          w="100%"
          pos="absolute"
          zIndex={100}
          top="50px"
          bg="white"
          borderRadius="md"
          boxShadow="lg"
          p={4}
        >
          {isLoading ? (
            <Center>
              <Spinner />
            </Center>
          ) : bikes && bikes.length === 0 ? (
            <Center>
              <Text>No assets found</Text>
            </Center>
          ) : (
            <Stack>
              {bikes?.map((bike) => (
                <Link
                  variant="unstyled"
                  _hover={{ bg: "gray.50" }}
                  borderRadius="md"
                  p={2}
                  as={RLink}
                  key={bike.uuid}
                  to={`/assets/${bike.uuid}/trips`}
                >
                  <Stack direction="row" spacing={4}>
                    <Flex alignItems="center">
                      <Image
                        bg="white"
                        p={1}
                        src={bike.image_url || undefined}
                        alt="bike image"
                        boxSize="40px"
                        borderRadius="md"
                        objectFit="contain"
                        marginRight={2}
                      />
                      <Flex direction="column" justify="center">
                        <Text fontWeight="600">
                          {bike.name}
                          {bike.serial_number &&
                            bike_sn_as_name_extension?.visible &&
                            bike.name.toUpperCase() !== bike.serial_number.toUpperCase() &&
                            `.${bike.serial_number}`}
                        </Text>
                        {/* shows serial number explicitly */}
                        {/* {bike.serial_number && bike_sn_as_name_extension?.visible
                          && bike.name.toUpperCase() !== bike.serial_number.toUpperCase() && (
                          <Text fontSize="0.7rem">
                            {bike.serial_number}
                          </Text>
                        )} */}
                        <Text fontSize="0.7rem">{bike.bicycle_model_name}</Text>
                      </Flex>
                    </Flex>
                  </Stack>
                </Link>
              ))}
            </Stack>
          )}
        </Box>
      )}
    </Box>
  )
}
